import React from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Copy, MessageCircle, KeyRound } from "lucide-react";
import { toast } from "sonner";

function whatsappLink(result) {
  let phone = (result.phone || "").replace(/\D/g, "");
  if (phone && !phone.startsWith("55")) phone = "55" + phone;
  const msg = encodeURIComponent(
    `Olá ${result.name}! Sua senha provisória de acesso ao app Clima Branca é: ${result.temp_password}\n` +
    `Acesse https://app.climabranca.com.br e troque a senha no primeiro acesso.`
  );
  return `https://wa.me/${phone}?text=${msg}`;
}

export default function ResetPasswordDialog({ open, onOpenChange, result }) {
  if (!result) return null;

  const copy = () => {
    navigator.clipboard?.writeText(result.temp_password);
    toast.success("Senha copiada!");
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="reset-password-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <KeyRound className="h-5 w-5 text-amber-500" /> Senha provisória gerada
          </DialogTitle>
          <DialogDescription>
            Compartilhe com <b>{result.name}</b>. No 1º acesso o app pedirá a troca da senha.
          </DialogDescription>
        </DialogHeader>
        <div className="rounded-lg bg-slate-100 p-4 text-center">
          <p className="text-2xl font-mono font-bold text-slate-800 tracking-wider" data-testid="temp-password-value">
            {result.temp_password}
          </p>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" className="flex-1 gap-1.5" onClick={copy} data-testid="copy-temp-password">
            <Copy className="h-4 w-4" /> Copiar
          </Button>
          <a href={whatsappLink(result)} target="_blank" rel="noopener noreferrer" className="flex-1" data-testid="send-temp-whatsapp">
            <Button className="w-full gap-1.5 bg-green-600 hover:bg-green-700">
              <MessageCircle className="h-4 w-4" /> WhatsApp
            </Button>
          </a>
        </div>
      </DialogContent>
    </Dialog>
  );
}
